/* eslint-disable react/jsx-key */
import { Box, Card, Grid, Typography } from '@mui/material';
import React from 'react';
import { filterOptions } from './FilterOptions';

const FilterCards = ({ applyImgFilters, updateFilters }) =>
{
	return (
		<Card
			sx={{
				height   : '38vh',
				padding  : 'var(--pixel16)',
				overflow : 'auto'
			}}
		>
			<Grid container spacing={1} >
				{filterOptions?.map((filterOption) => (
					<Grid item xs={6} sm={4} md={4} key={filterOption?.name}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} height={'var(--font100)'}>
							<Box
								component='img'
								onClick={() => updateFilters('filter', filterOption?.value)}
								src={applyImgFilters?.dataUrl}
								alt={filterOption?.name}
								sx={{
									width        : 'var(--percent100)',
									height       : 'var(--percent100)',
									filter       : filterOption?.value,
									borderRadius : 'var(--pixel8)',
									cursor       : 'pointer'
								}}
							/>
							<Typography fontSize='var(--pixel12)' textAlign='center' pt='var(--pixel4)'>
								{filterOption?.name}
							</Typography>
						</Box>
					</Grid>
				))}
			</Grid>
		</Card>

	);
};

export default FilterCards;
